import Button from '@components/Button/Button';
import Checkbox from '@components/Checkbox/Checkbox';
import Text from '@components/Text/Text';
import { useAuth } from '@hooks/useAuth';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useIntercom } from 'react-use-intercom';

export interface LogoutConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
}

const LogoutConfirmation: React.FC<LogoutConfirmationProps> = ({
  isOpen,
  onClose,
}: LogoutConfirmationProps) => {
  const { logout, revokeAccessTokens } = useAuth();
  const { shutdown } = useIntercom();
  const [logOutOfAllDevices, setLogOutOfAllDevices] = useState(false);

  const handleLogOutOfAllDevicesChange = () =>
    setLogOutOfAllDevices(!logOutOfAllDevices);

  const handleLogout = async () => {
    if (logOutOfAllDevices) {
      revokeAccessTokens();
    } else {
      logout();
    }
    shutdown();
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      PaperProps={{
        sx: {
          padding: 8,
          borderRadius: 7,
        },
      }}
    >
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <Text variant='h5' fontWeight='fontWeightBold'>
            <FormattedMessage id='profileMenu.sureWantToLogout' />
          </Text>
          <Checkbox
            data-testid='log-me-out-everywhere-checkbox'
            value={logOutOfAllDevices}
            onChange={handleLogOutOfAllDevicesChange}
            label={<FormattedMessage id='profileMenu.logMeOutOfAllDevices' />}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='secondary' onClick={onClose}>
          <FormattedMessage id='misc.no' />
        </Button>
        <Button
          data-testid='logout-confirmed-button'
          variant='primary'
          onClick={handleLogout}
          autoFocus
        >
          <FormattedMessage id='menu.logout' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmation;
